module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table-a"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.invoices), function(invoice, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(invoice.invoice_no))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.msg(invoice.title)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("cut")(invoice.title, 25)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.status))]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v(_vm._s(_vm._f("money")(invoice.total_ex_vat_dkk, 2)) + " kr.")]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [(_vm.hasMatchingEconomyPost(invoice)) ? _c('span', [_vm._v("✓")]) : _c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.copyInvoiceToEconomyPost(invoice)
        }
      }
    }, [_vm._v("Kopiér")])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "align-r",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "align-r"
  }, [_c('b', [_vm._v(_vm._s(_vm._f("money")(_vm.total, 2)) + " kr.")])]), _vm._v(" "), _c('td')])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Faktura #")]), _vm._v(" "), _c('th', [_vm._v("Tekst")]), _vm._v(" "), _c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Ex. moms")]), _vm._v(" "), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-553c36d7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DineroInvoices.vue
// module id = 603
// module chunks = 1